// @ts-nocheck
/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react';
import { PlusCircle, TrendingUp, Link as LinkIcon, Lock, Trash2 } from 'lucide-react';
import useAppStore from '../store'; // Default Import
import useAdminStore from '../store/adminStore';
import { PrivateCategory, PrivateItem } from '../store/types';

// --- CONFIG & STYLES ---
const COLORS = {
  gold: '#E6C299',
  slate900: '#0f172a',
  slate800: '#1e293b',
  slate700: '#334155',
  green: '#22c55e',
  red: '#ef4444',
};

const PAGE_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;700;800&family=Inter:wght@300;400;600;800&display=swap');

  .font-sans { font-family: 'Inter', sans-serif; }
  .font-mono-numbers { font-family: 'JetBrains Mono', monospace; font-variant-numeric: tabular-nums; }

  .bg-deep-space { background-color: #030303; }
  .text-phantom-gold { color: ${COLORS.gold}; }

  .carbon-weave-bg {
      background-color: #111;
      background-image:
          radial-gradient(circle at 100% 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
          radial-gradient(circle at 0 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
          radial-gradient(circle at 50% 100%, #1a1a1a 10%, #111 10%, #111 23%, #1a1a1a 23%, #1a1a1a 30%, #111 30%, #111 43%, #1a1a1a 43%, #1a1a1a 50%, #111 50%, #111 63%, #1a1a1a 63%, #1a1a1a 71%, transparent 71%, transparent),
          radial-gradient(circle at 100% 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent),
          radial-gradient(circle at 0 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent);
      background-size: 20px 20px;
  }

  .carbon-panel {
      position: relative;
      z-index: 10;
      border-radius: 1.5rem;
      border: 1px solid #2a2a2a;
      box-shadow: 0 30px 60px -15px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.05);
      overflow: visible;
  }

  .carbon-panel::before {
      content: '';
      position: absolute;
      inset: 0;
      background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.55));
      border-radius: inherit;
      pointer-events: none;
      z-index: 1;
  }

  .carbon-panel:hover {
      z-index: 4000;
  }

  .carbon-content {
      position: relative;
      z-index: 20;
      overflow: visible;
  }

  .metal-badge {
      background: linear-gradient(to bottom, #222, #0a0a0a);
      border: 1px solid #333;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.08), 0 4px 10px rgba(0,0,0,0.8);
      border-radius: 8px;
  }

  .led-gold {
      color: ${COLORS.gold};
      text-shadow: 0 0 10px rgba(230,194,153,0.45), 0 0 20px rgba(230,194,153,0.18);
  }

  .led-emerald {
      color: #34d399;
      text-shadow: 0 0 10px rgba(52,211,153,0.45), 0 0 20px rgba(52,211,153,0.18);
  }

  .led-red {
      color: #f87171;
      text-shadow: 0 0 10px rgba(248,113,113,0.45), 0 0 20px rgba(248,113,113,0.18);
  }

  /* Custom Scrollbar */
  .custom-scrollbar::-webkit-scrollbar { width: 8px; height: 8px; }
  .custom-scrollbar::-webkit-scrollbar-track { background: #050505; }
  .custom-scrollbar::-webkit-scrollbar-thumb { background: #2f2f2f; border-radius: 4px; }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #444; }

  /* Input Number Arrows entfernen */
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
  input[type=number] { -moz-appearance: textfield; }

  /* --- TOOLTIP SYSTEM --- */
  [data-tooltip] {
      position: relative;
  }

  [data-tooltip]::after {
      content: attr(data-tooltip);
      position: absolute;
      left: 50%;
      bottom: 100%;
      margin-bottom: 16px;
      transform: translateX(-50%);
      background: ${COLORS.gold};
      color: #111111;
      border: 1px solid rgba(0, 0, 0, 0.55);
      padding: 12px 16px;
      border-radius: 12px;
      font-family: 'Inter', sans-serif;
      font-size: 0.82rem;
      font-weight: 800;
      line-height: 1.45;
      text-align: center;
      text-transform: none !important;
      letter-spacing: normal !important;
      white-space: normal;
      width: 340px;
      max-width: min(340px, 78vw);
      opacity: 0;
      pointer-events: none;
      visibility: hidden;
      transition: opacity 0.18s ease-in-out, transform 0.18s ease-in-out;
      z-index: 999999;
      box-shadow:
        0 22px 50px -12px rgba(0, 0, 0, 0.95),
        0 4px 18px rgba(0, 0, 0, 0.55);
  }

  [data-tooltip]:hover {
      z-index: 6000;
  }

  [data-tooltip]:hover::after {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(-3px);
  }

  /* Leere Tooltips komplett deaktivieren */
  [data-tooltip=""]::after {
      display: none !important;
  }

  .tooltip-dot {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      border-radius: 9999px;
      background: linear-gradient(to bottom, #262626, #080808);
      border: 1px solid rgba(230,194,153,0.45);
      color: ${COLORS.gold};
      font-size: 11px;
      font-weight: 900;
      line-height: 1;
      cursor: help;
      box-shadow: 0 0 10px rgba(230,194,153,0.18);
      user-select: none;
      flex-shrink: 0;
  }

  /* Formula Mode Styles */
  .formula-mode {
      font-family: 'JetBrains Mono', monospace;
      font-size: 0.7rem !important;
      color: #94a3b8 !important;
      font-weight: normal !important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }

  /* ============================================================
     LIGHT-MODE OVERRIDES (Ring 4a) — Dark Mode bleibt pixelidentisch,
     da alle Regeln nur unter html:not(.dark) greifen.
     ============================================================ */
  html:not(.dark) .bg-deep-space { background-color: var(--pe-bg-primary); }
  html:not(.dark) .text-phantom-gold { color: #8D6435; }
  html:not(.dark) .carbon-weave-bg {
      background-color: var(--pe-bg-elevated);
      background-image: none;
  }
  html:not(.dark) .carbon-panel {
      background-color: var(--pe-bg-card);
      border-color: #D6D3D1;
      box-shadow: 0 10px 30px -12px rgba(28,25,23,0.15);
  }
  html:not(.dark) .carbon-panel::before { background: none; }
  html:not(.dark) .carbon-panel::after { background: none; }
  html:not(.dark) .metal-badge {
      background: linear-gradient(to bottom, var(--pe-bg-elevated), var(--pe-bg-tile-header));
      border-color: #B8B2AC;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.8), 0 2px 6px rgba(28,25,23,0.08);
  }
  html:not(.dark) .led-gold { color: #8D6435; text-shadow: none; }
  html:not(.dark) .led-emerald { color: #047857; text-shadow: none; }
  html:not(.dark) .led-red { color: #B91C1C; text-shadow: none; }
  html:not(.dark) .custom-scrollbar::-webkit-scrollbar-track { background: #EAE7E2; }
  html:not(.dark) .custom-scrollbar::-webkit-scrollbar-thumb { background: #B8B2AC; }
  html:not(.dark) .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #8D8781; }
  html:not(.dark) .formula-mode { color: #57534E !important; }
  html:not(.dark) .tooltip-dot {
      background: linear-gradient(to bottom, var(--pe-bg-card), var(--pe-bg-tile-header));
      border-color: rgba(141,100,53,0.45);
      color: #8D6435;
      box-shadow: 0 0 6px rgba(141,100,53,0.15);
  }
`;

// --- HELPER ---
const formatNumber = (val: number) => {
  return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(val || 0);
};

// --- BUFFERED INPUT COMPONENTS ---

const BufferedInputCell = ({ value, onCommit, placeholder = "0", tooltip, currency = "EUR" }: any) => {
    const [localValue, setLocalValue] = useState<string>(value?.toString() || '');

    useEffect(() => {
        setLocalValue(value === 0 ? '' : value?.toString() || '');
    }, [value]);

    const handleBlur = () => {
        const numValue = parseInt(localValue) || 0;
        if (numValue !== value) {
            onCommit(numValue);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            (e.target as HTMLInputElement).blur();
        }
    };

    return (
        <div className="relative w-full h-full" data-tooltip={tooltip || ''}>
            <input
                type="number"
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                onFocus={(e) => e.target.select()}
                className="w-full h-10 bg-pe-input dark:bg-black text-pe-text dark:text-white text-center border border-pe-border-strong dark:border-[#333] rounded-lg focus:border-[#E6C299] focus:ring-1 focus:ring-[#E6C299] outline-none font-mono-numbers text-lg transition-colors placeholder-stone-400 dark:placeholder-slate-600 pr-10 shadow-inner"
                placeholder={placeholder}
            />
            <div className="absolute right-2 top-0 bottom-0 flex items-center pointer-events-none">
                <span className="text-stone-500 dark:text-slate-500 font-bold text-[0.7rem] tracking-wider uppercase">{currency}</span>
            </div>
        </div>
    );
};

const BufferedTextInput = ({ value, onCommit, placeholder }: any) => {
    const [localValue, setLocalValue] = useState(value || '');

    useEffect(() => {
        setLocalValue(value || '');
    }, [value]);

    const handleBlur = () => {
        if (localValue !== value) {
            onCommit(localValue);
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            (e.target as HTMLInputElement).blur();
        }
    };

    return (
        <input
            type="text"
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            onFocus={(e) => e.target.select()}
            className="bg-pe-input dark:bg-black text-pe-text dark:text-white text-sm border border-pe-border-strong dark:border-[#333] rounded-lg px-3 h-10 w-full focus:border-[#E6C299] focus:ring-1 focus:ring-[#E6C299] outline-none placeholder-stone-400 dark:placeholder-slate-600 font-medium transition-colors shadow-inner"
            placeholder={placeholder}
        />
    );
};

// --- READ-ONLY DISPLAY COMPONENT (UPDATED FOR FORMULAS) ---
const ReadOnlyDisplay = ({ value, label, currency, formula }: any) => {
    const showFormulas = useAppStore(state => state.showFormulas);

    return (
        <div className="bg-pe-tile-header dark:bg-slate-800 border border-pe-border dark:border-slate-700 rounded-xl p-1.5 px-3 min-w-[120px] flex flex-col justify-center h-full shadow-inner">
            <span className="text-[10px] text-pe-muted dark:text-slate-400 uppercase tracking-wider mb-0.5">{label}</span>
            <div className={`font-mono-numbers text-pe-accent-text dark:text-[#E6C299] font-bold text-lg flex items-baseline gap-1 ${showFormulas ? 'formula-mode' : ''}`}>
                {showFormulas && formula ? (
                    <span>{formula}</span>
                ) : (
                    <>
                        {formatNumber(value)}
                        <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                    </>
                )}
            </div>
        </div>
    );
};

const ResultCell = ({ value, label = "EUR" }: any) => (
   <div className="relative w-full h-10 bg-pe-tile-header dark:bg-slate-800 border border-pe-border dark:border-slate-700 rounded-lg flex items-center justify-center shadow-inner">
      <span className="text-pe-accent-text dark:text-[#E6C299] font-mono-numbers text-lg font-bold">
          {typeof value === 'number' ? formatNumber(value) : value}
      </span>
      {label && (
          <div className="absolute right-2 top-0 bottom-0 flex items-center pointer-events-none">
              <span className="text-stone-500 dark:text-slate-500 font-bold text-[0.7rem] tracking-wider uppercase">{label}</span>
          </div>
      )}
  </div>
);

const SelectCell = ({ value, onChange, options, tooltip }: any) => (
  <div className="relative w-full h-full" data-tooltip={tooltip || ''}>
      <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full h-10 bg-pe-input dark:bg-black text-pe-accent-text dark:text-[#E6C299] text-center font-medium rounded-lg border border-pe-border-strong dark:border-[#333] outline-none focus:border-[#E6C299] focus:ring-1 focus:ring-[#E6C299] cursor-pointer shadow-inner"
      >
          {options.map((opt: any) => (
              <option key={opt.value} value={opt.value} className="bg-pe-card dark:bg-slate-900 text-pe-text dark:text-white">{opt.label}</option>
          ))}
      </select>
  </div>
);

// --- MAIN PAGE COMPONENT ---

const PrivatkostenKompassPage: React.FC = () => {
  const clientData = useAppStore(state => state.clientData);
  const settings = useAppStore(state => state.settings); // 💉 CHIRURGIE-FIX: Settings integriert
  const updateNestedClientData = useAppStore(state => state.updateNestedClientData);
  const showFormulas = useAppStore(state => state.showFormulas);
  const isGodMode = !!useAdminStore(state => state.impersonatedClientId);

  const { privateCostData, unternehmerData } = clientData;
  // 💉 CHIRURGIE-FIX: Dynamische Währungsauswertung über Settings
  const currency = settings?.country?.currency === 'CHF' ? 'CHF' : 'EUR';

  const isGmbh = clientData.unternehmensform === 'GmbH';
  const gfZielgehalt = Number(unternehmerData?.gfZielgehalt);
  const plannedGfGehalt =
    Number.isFinite(gfZielgehalt) && gfZielgehalt > 0 ? gfZielgehalt : 5000;
  const plannedEntnahme = unternehmerData?.entnahme || 0;
  const plannedSozial = unternehmerData?.sozialkosten || 0;
  // GmbH: Planung = GF-Zielgehalt aus Unternehmerwerte; sonst Entnahme + Sozialkosten
  const totalPlanned = isGmbh ? plannedGfGehalt : plannedEntnahme + plannedSozial;

  const updateMonthlyItem = (catIndex: number, itemIndex: number, field: string, val: any) => {
      const currentCats = privateCostData?.monthlyCats || [];
      const newCats = JSON.parse(JSON.stringify(currentCats));

      if (newCats[catIndex] && newCats[catIndex].items[itemIndex]) {
        newCats[catIndex].items[itemIndex][field] = val;
        updateNestedClientData('privateCostData', 'monthlyCats', newCats);
      }
  };

  const addMonthlyRow = (catIndex: number) => {
      const currentCats = privateCostData?.monthlyCats || [];
      const newCats = JSON.parse(JSON.stringify(currentCats));

      if (newCats[catIndex]) {
        newCats[catIndex].items.push({ name: '', value: 0, fixed: false });
        updateNestedClientData('privateCostData', 'monthlyCats', newCats);
      }
  };

  const deleteMonthlyItem = (catIndex: number, itemIndex: number) => {
      const currentCats = privateCostData?.monthlyCats || [];
      const newCats = JSON.parse(JSON.stringify(currentCats));

      if (newCats[catIndex] && newCats[catIndex].items[itemIndex]) {
          newCats[catIndex].items.splice(itemIndex, 1);
          updateNestedClientData('privateCostData', 'monthlyCats', newCats);
      }
  };

  const updatePeriodicItem = (index: number, field: string, val: any) => {
      const currentItems = privateCostData?.periodicItems || [];
      const newItems = [...currentItems];

      if (newItems[index]) {
        newItems[index] = { ...newItems[index], [field]: val };
        updateNestedClientData('privateCostData', 'periodicItems', newItems);
      }
  };

  const addPeriodicRow = () => {
      const currentItems = privateCostData?.periodicItems || [];
      const newItems = [...currentItems, { name: '', value: 0, frequency: 12, fixed: false }];
      updateNestedClientData('privateCostData', 'periodicItems', newItems);
  };

  const deletePeriodicItem = (index: number) => {
      const currentItems = privateCostData?.periodicItems || [];
      const newItems = [...currentItems];
      newItems.splice(index, 1);
      updateNestedClientData('privateCostData', 'periodicItems', newItems);
  };

  const { sumLivingMonthly, sumSocialMonthly } = useMemo(() => {
      let living = 0;
      let social = 0;
      const cats = privateCostData?.monthlyCats || [];

      cats.forEach((cat: PrivateCategory) => {
          const catSum = cat.items.reduce((s: number, i: PrivateItem) => s + i.value, 0);
          if (cat.type === 'social') {
              social += catSum;
          } else {
              living += catSum;
          }
      });
      return { sumLivingMonthly: living, sumSocialMonthly: social };
  }, [privateCostData?.monthlyCats]);

  const sumPeriodicMonthlyShare = useMemo(() => {
      const items = privateCostData?.periodicItems || [];
      return items.reduce((acc: number, item: PrivateItem) => {
          return acc + (item.value / (item.frequency || 12));
      }, 0);
  }, [privateCostData?.periodicItems]);

  const actualNeededLiving = sumLivingMonthly + sumPeriodicMonthlyShare;
  const actualNeededSocial = sumSocialMonthly;
  const totalNeeded = actualNeededLiving + actualNeededSocial;

  const diff = totalPlanned - totalNeeded;
  const isCovered = diff >= 0;

  const totalNeededRounded = Math.ceil(totalNeeded / 50) * 50;
  const STRATEGIC_HINT = "Planen Sie Puffer für Kostensteigerungen ein. Wichtig: Vergessen Sie bei der Lebenshaltung private Rücklagen nicht! Unternehmertum muss sich lohnen – kalkulieren Sie lieber großzügig.";

  const safeMonthlyCats = privateCostData?.monthlyCats || [];
  const safePeriodicItems = privateCostData?.periodicItems || [];

  return (
      <div className="min-h-screen bg-deep-space text-pe-text dark:text-slate-200 pb-40 font-sans selection:bg-[#E6C299] selection:text-black custom-scrollbar relative">
          <style>{PAGE_STYLES}</style>

          {/* Gleiche Breite wie Inhalt (kein full-bleed fixed) — sticky unter App-Header / God-Mode */}
          <div className="w-full space-y-8">
              <div
                  className={`sticky z-30 carbon-weave-bg bg-pe-elevated/95 dark:bg-[#030303]/95 border border-pe-border dark:border-[#1a1a1a] rounded-xl shadow-2xl backdrop-blur-md ${
                      isGodMode ? 'top-12 md:top-40' : 'top-2 md:top-32'
                  }`}
              >
                  <div className="p-3">
                      <div className="flex flex-col md:flex-row justify-between items-center gap-4 min-w-0">

                          {/* PLANUNG (Aus Unternehmer Store) */}
                          <div className="flex flex-col min-w-0">
                              <div className="flex items-center gap-1 text-[10px] text-pe-accent-text dark:text-[#E6C299] uppercase tracking-wider mb-1">
                                  <LinkIcon size={12} />
                                  <span className="font-bold">
                                      {isGmbh
                                          ? 'Datenquelle: GmbH · GF-Zielgehalt'
                                          : 'Datenquelle: Unternehmer-Planung'}
                                  </span>
                              </div>

                              <div className="flex flex-wrap items-center gap-2 min-w-0">
                                  {isGmbh ? (
                                      <>
                                          <div className="relative group" title="Kommt aus 'Unternehmerwerte' > GmbH · GF-Zielgehalt">
                                              <ReadOnlyDisplay
                                                value={plannedGfGehalt}
                                                label="GF-Zielgehalt"
                                                currency={currency}
                                                formula="Store > Unternehmer > gfZielgehalt"
                                              />
                                              <div className="absolute top-1 right-1 text-stone-400 dark:text-slate-600"><Lock size={10} /></div>
                                          </div>

                                          <span className="text-pe-muted dark:text-slate-400 font-bold mx-1">=</span>

                                          <div className="h-full flex flex-col justify-center px-2">
                                              <span className="text-[10px] text-stone-500 dark:text-slate-500 uppercase tracking-wider mb-0.5">Gesamt Verfügbar</span>
                                              <span className={`font-bold text-pe-accent-text dark:text-[#E6C299] text-xl font-mono-numbers flex items-baseline gap-1 ${showFormulas ? 'formula-mode' : 'led-gold'}`}>
                                                  {showFormulas ? "GF-Zielgehalt" : (
                                                      <>
                                                          {formatNumber(totalPlanned)}
                                                          <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                                                      </>
                                                  )}
                                              </span>
                                          </div>
                                      </>
                                  ) : (
                                      <>
                                          <div className="relative group" title="Kommt aus 'Unternehmer' > 'Entnahme'">
                                              <ReadOnlyDisplay
                                                value={plannedEntnahme}
                                                label="Priv. Entnahme"
                                                currency={currency}
                                                formula="Store > Unternehmer > Entnahme"
                                              />
                                              <div className="absolute top-1 right-1 text-stone-400 dark:text-slate-600"><Lock size={10} /></div>
                                          </div>

                                          <span className="text-stone-500 dark:text-slate-500 font-bold">+</span>

                                          <div className="relative group" title="Kommt aus 'Unternehmer' > 'Sozialkosten'">
                                              <ReadOnlyDisplay
                                                value={plannedSozial}
                                                label="Sozialkosten"
                                                currency={currency}
                                                formula="Store > Unternehmer > Sozial"
                                              />
                                              <div className="absolute top-1 right-1 text-stone-400 dark:text-slate-600"><Lock size={10} /></div>
                                          </div>

                                          <span className="text-pe-muted dark:text-slate-400 font-bold mx-1">=</span>

                                          <div className="h-full flex flex-col justify-center px-2">
                                              <span className="text-[10px] text-stone-500 dark:text-slate-500 uppercase tracking-wider mb-0.5">Gesamt Verfügbar</span>
                                              <span className={`font-bold text-pe-accent-text dark:text-[#E6C299] text-xl font-mono-numbers flex items-baseline gap-1 ${showFormulas ? 'formula-mode' : 'led-gold'}`}>
                                                  {showFormulas ? "Entnahme + Sozial" : (
                                                      <>
                                                          {formatNumber(totalPlanned)}
                                                          <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                                                      </>
                                                  )}
                                              </span>
                                          </div>
                                      </>
                                  )}
                              </div>
                          </div>

                          {/* STATUS (Right) */}
                          <div className={`flex items-center gap-3 px-6 py-3 rounded-xl border shadow-inner shrink-0 ${isCovered ? 'bg-emerald-100/80 dark:bg-emerald-950/20 border-emerald-300 dark:border-emerald-500/30' : 'bg-red-100/80 dark:bg-red-950/20 border-red-300 dark:border-red-500/30'}`}>
                              <div className="text-right">
                                  <div className="text-xs text-pe-muted dark:text-slate-400 uppercase tracking-wider mb-1">Deckungs-Status</div>
                                  <div className={`font-bold text-2xl font-mono-numbers flex items-baseline justify-end gap-1 ${isCovered ? 'text-emerald-700 dark:text-emerald-400 led-emerald' : 'text-red-600 dark:text-red-400 led-red'} ${showFormulas ? 'formula-mode' : ''}`}>
                                      {showFormulas ? "Planung - Bedarf" : (
                                          <>
                                              {diff > 0 ? '+' : ''}{formatNumber(diff)}
                                              <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                                          </>
                                      )}
                                  </div>
                              </div>
                              <div className={`h-12 w-2 ${isCovered ? 'bg-emerald-500' : 'bg-red-500'} rounded-full shadow-[0_0_15px_rgba(0,0,0,0.5)]`}></div>
                          </div>

                      </div>
                  </div>
              </div>

          {/* Inhalt — gleiche Spaltenbreite wie die Leiste oben */}
          <div className="space-y-8">

              <div className="text-center mb-6 carbon-weave-bg rounded-xl border border-pe-border dark:border-[#2a2a2a] px-6 py-8">
                  <h1 className="text-4xl md:text-5xl font-black text-pe-text dark:text-white tracking-tight uppercase">
                      Privatkosten <span className="text-phantom-gold">Kompass</span>
                  </h1>
                  <p className="text-stone-500 dark:text-slate-500 text-xs font-bold tracking-[0.2em] uppercase mt-2">
                      Executive Carbon Console
                  </p>
                  <p className="text-pe-muted dark:text-slate-400 text-sm mt-4">
                      {isGmbh
                          ? 'Ermitteln Sie Ihren tatsächlichen Bedarf im Vergleich zum GF-Zielgehalt (GmbH).'
                          : 'Ermitteln Sie Ihren tatsächlichen Bedarf im Vergleich zur geplanten Entnahme.'}
                  </p>
              </div>

              {/* === GRID LAYOUT (2x2 for Monthly) === */}
              <h2 className="text-lg font-bold text-pe-accent-text dark:text-[#E6C299] border-b border-pe-border dark:border-[#222] pb-2 px-4 py-2 carbon-weave-bg rounded-lg uppercase tracking-widest">
                  Monatliche Fixkosten
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {safeMonthlyCats.map((cat: PrivateCategory, catIndex: number) => (
                      <div
                          key={cat.id}
                          className="carbon-panel flex flex-col shadow-lg transition-transform hover:scale-[1.005] relative bg-pe-card dark:bg-[#030303]"
                          data-tooltip={STRATEGIC_HINT}
                      >
                          <div className="carbon-content">
                              {/* HEADER */}
                              <div className="p-2 px-4 font-bold flex justify-between items-center h-14 border-b border-pe-border dark:border-[#333] rounded-t-[1.5rem] carbon-weave-bg">
                                  <div className="flex items-center gap-2 text-pe-text dark:text-white uppercase tracking-wide">
                                      <span>{cat.title}</span>
                                      {cat.type === 'social' && <span className="text-[10px] bg-blue-100/70 dark:bg-blue-950/30 text-blue-800 dark:text-blue-300 px-1.5 py-0.5 rounded uppercase border border-blue-300 dark:border-blue-500/30">Sozial</span>}
                                  </div>
                                  <div className="w-32">
                                      {showFormulas ? (
                                          <div className="formula-mode text-center">SUM({cat.id})</div>
                                      ) : (
                                          <ResultCell value={cat.items.reduce((s: number, i: PrivateItem) => s + i.value, 0)} label={currency} />
                                      )}
                                  </div>
                              </div>
                              <div className="p-4 space-y-3 flex-grow rounded-b-[1.5rem]">
                                  {cat.items.map((item: PrivateItem, itemIndex: number) => (
                                      <div key={itemIndex} className="grid grid-cols-[1fr_100px_32px] gap-2 items-center h-10">
                                          {item.fixed ? (
                                              <div className="text-pe-muted dark:text-slate-400 text-sm px-1 truncate select-none col-span-1" title={item.name}>
                                                  {item.name}
                                              </div>
                                          ) : (
                                              <BufferedTextInput
                                                  value={item.name}
                                                  onCommit={(val: string) => updateMonthlyItem(catIndex, itemIndex, 'name', val)}
                                                  placeholder="Neuer Eintrag..."
                                              />
                                          )}
                                          <div className="col-span-1">
                                              <BufferedInputCell
                                                  value={item.value}
                                                  onCommit={(val: number) => updateMonthlyItem(catIndex, itemIndex, 'value', val)}
                                                  currency={currency}
                                              />
                                          </div>
                                          <div className="col-span-1 flex justify-center">
                                              {!item.fixed && (
                                                  <button
                                                      onClick={() => deleteMonthlyItem(catIndex, itemIndex)}
                                                      className="text-stone-400 dark:text-slate-600 hover:text-red-600 dark:hover:text-red-500 transition-colors p-1"
                                                      title="Zeile löschen"
                                                  >
                                                      <Trash2 size={16} />
                                                  </button>
                                              )}
                                          </div>
                                      </div>
                                  ))}
                                  <div className="pt-2 border-t border-pe-border dark:border-[#333] mt-2">
                                      <button
                                          onClick={() => addMonthlyRow(catIndex)}
                                          className="text-xs text-pe-accent-text dark:text-[#E6C299] hover:text-pe-text dark:hover:text-white flex items-center gap-1 transition-colors opacity-80 hover:opacity-100 uppercase tracking-wider font-bold"
                                      >
                                          <PlusCircle size={16} /> Weitere Zeile
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  ))}
              </div>

              {/* === PERIODIC COSTS (Full Width) === */}
              <div className="space-y-4">
                  <h2 className="text-lg font-bold text-pe-accent-text dark:text-[#E6C299] border-b border-pe-border dark:border-[#222] pb-2 px-4 py-2 carbon-weave-bg rounded-lg mt-4 uppercase tracking-widest">
                      Periodische Zahlungen (Jährlich/Quartal)
                  </h2>
                  <div className="carbon-panel p-4 shadow-lg bg-pe-card dark:bg-[#030303]">
                      <div className="carbon-content">
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                              {safePeriodicItems.map((item: PrivateItem, index: number) => (
                                  <div key={index} className="grid grid-cols-12 gap-2 items-center border-b border-pe-border dark:border-[#333] pb-2 mb-2 md:mb-0 h-12">
                                      <div className="col-span-4 h-full flex items-center">
                                          {item.fixed ? (
                                              <div className="text-pe-muted dark:text-slate-400 text-sm px-1 truncate select-none">{item.name}</div>
                                          ) : (
                                              <BufferedTextInput
                                                  value={item.name}
                                                  onCommit={(val: string) => updatePeriodicItem(index, 'name', val)}
                                                  placeholder="Neuer Eintrag..."
                                              />
                                          )}
                                      </div>
                                      <div className="col-span-3">
                                          <BufferedInputCell
                                              value={item.value}
                                              onCommit={(val: number) => updatePeriodicItem(index, 'value', val)}
                                              tooltip="Voller Betrag (z. B. Jahresrechnung)"
                                              currency={currency}
                                          />
                                      </div>
                                      <div className="col-span-2">
                                          <SelectCell
                                              value={item.frequency}
                                              onChange={(val: any) => updatePeriodicItem(index, 'frequency', parseInt(val))}
                                              options={[{ value: 12, label: 'Jahr' }, { value: 6, label: 'Halbj' }, { value: 3, label: 'Quart' }]}
                                              tooltip="Zahlungsintervall wählen. Monatlicher Anteil wird automatisch berechnet."
                                          />
                                      </div>
                                      <div className="col-span-2">
                                          <div className="relative w-full h-10 bg-pe-tile-header dark:bg-slate-800 border border-pe-border dark:border-slate-700 rounded-lg flex items-center justify-center opacity-90 shadow-inner">
                                              <span className={`text-pe-accent-text dark:text-[#E6C299] font-mono-numbers text-sm font-bold ${showFormulas ? 'formula-mode' : ''}`}>
                                                  {showFormulas ? "Wert / Freq" : formatNumber(item.value / (item.frequency || 12))}
                                              </span>
                                              {!showFormulas && (
                                                  <div className="absolute right-2 top-0 bottom-0 flex items-center pointer-events-none">
                                                      <span className="text-stone-500 dark:text-slate-500 font-bold text-[0.7rem] tracking-wider uppercase">/M</span>
                                                  </div>
                                              )}
                                          </div>
                                      </div>
                                      <div className="col-span-1 flex justify-center">
                                          {!item.fixed && (
                                              <button
                                                  onClick={() => deletePeriodicItem(index)}
                                                  className="text-stone-400 dark:text-slate-600 hover:text-red-600 dark:hover:text-red-500 transition-colors p-1"
                                                  title="Zeile löschen"
                                              >
                                                  <Trash2 size={16} />
                                              </button>
                                          )}
                                      </div>
                                  </div>
                              ))}
                          </div>
                          <button
                              onClick={addPeriodicRow}
                              className="text-xs text-pe-accent-text dark:text-[#E6C299] hover:text-pe-text dark:hover:text-white flex items-center gap-1 mt-4 transition-colors opacity-80 hover:opacity-100 uppercase tracking-wider font-bold"
                          >
                              <PlusCircle size={16} /> Periodischen Posten hinzufügen
                          </button>
                      </div>
                  </div>
              </div>

              {/* === DATA EXPORT SECTION (Static Detail View) === */}
              <div className="carbon-panel mt-12 mb-12 p-6 shadow-2xl bg-pe-card dark:bg-[#030303]">
                  <div className="carbon-content">
                      <div className="flex items-center gap-2 mb-6 border-b border-pe-border dark:border-[#333] pb-4 px-3 py-2 carbon-weave-bg rounded-lg">
                          <span className="text-pe-accent-text dark:text-[#E6C299]"><TrendingUp size={20} /></span>
                          <h3 className="text-xl font-bold text-pe-text dark:text-white tracking-wide uppercase">Abgleich: Bedarf vs. Planung</h3>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                          {/* 1. PRIVATE ENTNAHME */}
                          <div className="bg-stone-100/60 dark:bg-black/60 p-5 rounded-2xl border border-blue-500/20 relative overflow-hidden group hover:border-blue-500/40 transition-colors shadow-xl">
                              <div className="absolute top-0 left-0 w-1 h-full bg-blue-500"></div>
                              <h4 className="text-pe-muted dark:text-slate-400 text-xs uppercase tracking-widest mb-2 font-bold">Feld 1: Private Entnahme (Bedarf)</h4>
                              <div className={`text-3xl font-bold text-pe-accent-text dark:text-[#E6C299] mb-1 font-mono-numbers flex items-baseline gap-2 ${showFormulas ? 'formula-mode' : 'led-gold'}`}>
                                  {showFormulas ? "Summe(Lebenshaltung)" : (
                                      <>
                                          {formatNumber(actualNeededLiving)}
                                          <span className="text-stone-500 dark:text-slate-500 text-[0.4em] font-sans font-bold">{currency}</span>
                                      </>
                                  )}
                              </div>
                              <div className="text-xs text-stone-500 dark:text-slate-500">
                                  Enthält: Wohnen, Mobilität, Leben & anteilige jährliche Kosten.
                              </div>
                              <div className="mt-4 pt-3 border-t border-pe-border dark:border-[#333] flex justify-between items-center text-sm">
                                  <span className="text-pe-muted dark:text-slate-400">
                                      {isGmbh ? 'GF-Zielgehalt (gesamt):' : 'Verfügbar lt. Planung:'}
                                  </span>
                                  <span className={`font-mono-numbers flex items-baseline gap-1 ${
                                      (isGmbh ? plannedGfGehalt : plannedEntnahme) >= actualNeededLiving
                                          ? "text-emerald-700 dark:text-emerald-400"
                                          : "text-red-600 dark:text-red-400"
                                  } ${showFormulas ? 'formula-mode' : ''}`}>
                                      {showFormulas ? (isGmbh ? "Store > gfZielgehalt" : "Store > Entnahme") : (
                                          <>
                                              {formatNumber(isGmbh ? plannedGfGehalt : plannedEntnahme)}
                                              <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                                          </>
                                      )}
                                  </span>
                              </div>
                          </div>

                          {/* 2. SOZIALKOSTEN */}
                          <div className="bg-stone-100/60 dark:bg-black/60 p-5 rounded-2xl border border-purple-500/20 relative overflow-hidden group hover:border-purple-500/40 transition-colors shadow-xl">
                              <div className="absolute top-0 left-0 w-1 h-full bg-purple-500"></div>
                              <h4 className="text-pe-muted dark:text-slate-400 text-xs uppercase tracking-widest mb-2 font-bold">Feld 2: Sozialkosten (Bedarf)</h4>
                              <div className={`text-3xl font-bold text-pe-accent-text dark:text-[#E6C299] mb-1 font-mono-numbers flex items-baseline gap-2 ${showFormulas ? 'formula-mode' : 'led-gold'}`}>
                                  {showFormulas ? "Summe(Vorsorge)" : (
                                      <>
                                          {formatNumber(actualNeededSocial)}
                                          <span className="text-stone-500 dark:text-slate-500 text-[0.4em] font-sans font-bold">{currency}</span>
                                      </>
                                  )}
                              </div>
                              <div className="text-xs text-stone-500 dark:text-slate-500">
                                  Enthält: Kategorie "Vorsorge & Gesundheit".
                              </div>
                              <div className="mt-4 pt-3 border-t border-pe-border dark:border-[#333] flex justify-between items-center text-sm">
                                  <span className="text-pe-muted dark:text-slate-400">
                                      {isGmbh ? 'Deckungsstatus gesamt:' : 'Verfügbar lt. Planung:'}
                                  </span>
                                  <span className={`font-mono-numbers flex items-baseline gap-1 ${
                                      isGmbh
                                          ? (isCovered ? "text-emerald-700 dark:text-emerald-400" : "text-red-600 dark:text-red-400")
                                          : (plannedSozial >= actualNeededSocial ? "text-emerald-700 dark:text-emerald-400" : "text-red-600 dark:text-red-400")
                                  } ${showFormulas ? 'formula-mode' : ''}`}>
                                      {showFormulas ? (isGmbh ? "GF - Bedarf" : "Store > Sozial") : (
                                          <>
                                              {isGmbh
                                                  ? `${diff > 0 ? '+' : ''}${formatNumber(diff)}`
                                                  : formatNumber(plannedSozial)}
                                              <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                                          </>
                                      )}
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>

          </div>
          </div>

          {/* === FIXED FOOTER (RESULT) — gleiche Content-Breite wie die Seite === */}
          <div className="fixed bottom-0 left-0 right-0 md:left-16 z-40 pointer-events-none">
              <div className="max-w-7xl mx-auto px-4 pb-4 pointer-events-auto">
                  <div className="bg-pe-bg/95 dark:bg-black/95 border border-pe-border dark:border-[#222] rounded-xl shadow-2xl py-4 px-4 backdrop-blur-sm">
                      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                  <div className="flex items-center gap-4">
                      <div className="text-right hidden md:block">
                          <div className="text-xs text-stone-500 dark:text-slate-500 uppercase tracking-widest">Rechnerisch</div>
                          <div className={`font-mono-numbers text-pe-muted dark:text-slate-400 text-lg flex items-baseline justify-end gap-1 ${showFormulas ? 'formula-mode' : ''}`}>
                              {showFormulas ? "Feld 1 + Feld 2" : (
                                  <>
                                      {formatNumber(totalNeeded)}
                                      <span className="text-stone-500 dark:text-slate-500 text-[0.6em] font-sans font-bold">{currency}</span>
                                  </>
                              )}
                          </div>
                      </div>
                  </div>

                  <div className="flex flex-col items-center md:items-end">
                      <span className="text-[#8D6435]/80 dark:text-[#E6C299]/80 uppercase text-[10px] tracking-[0.2em] mb-0.5">Empfohlener Unternehmerlohn (aufgerundet)</span>
                      <span className={`text-pe-accent-text dark:text-[#E6C299] font-bold text-4xl md:text-5xl tracking-tight leading-none font-mono-numbers drop-shadow-lg flex items-baseline gap-2 ${showFormulas ? 'formula-mode' : 'led-gold'}`}>
                          {showFormulas ? "Rechnerisch + Puffer" : (
                              <>
                                  {formatNumber(totalNeededRounded)}
                                  <span className="text-stone-500 dark:text-slate-500 text-[0.3em] font-sans font-bold translate-y-[-4px]">{currency}</span>
                              </>
                          )}
                      </span>
                  </div>
                      </div>
                  </div>
              </div>
          </div>

      </div>
  );
};

export default PrivatkostenKompassPage;